import { CommonModule } from "@angular/common";
import { Component, OnInit, AfterViewInit, ViewChild, VERSION, ElementRef, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UtilityService } from 'src/app/services/utility.service';
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { FormControl, FormGroup, NgForm, FormBuilder } from "@angular/forms";
import { DrupalRESTService } from "src/app/services/drupal-rest.service";
import { ActivatedRoute, Event, Params, Router } from "@angular/router";
import { saveAs } from 'file-saver';
import moment from "moment";
import { ViewTableComponent } from "../../base/view-table/view-table.component";
import { AuthService } from 'src/app/services/auth.service';
import { PrintService } from 'src/app/services/print.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { RefreshService } from 'src/app/services/refresh.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { WeekYearChangeEvent } from '../../shared/week-year-selector/week-year-selector.component';
import { LoggerService } from '../../../services/logger.service';

@Component({
  selector: 'app-ami-staff-performance',
  templateUrl: './ami-staff-performance.component.html',
  styleUrls: ['./ami-staff-performance.component.css']
})
export class AmiStaffPerformanceComponent extends ViewTableComponent implements OnInit {

  override displayedColumns: string[] = [
    'name',
    'staff_type',
    'number_of_guest',
    'de/bonus',
    'private_lessons',
    'non_unit_coaching',
    'number_in_class',
    'dor_sanct_competition',
    'showcase_medal_ball',
    'party_time_non_unit',
    'interview_department',
    'renewal_department',
  ];

  // Column totals for the on-screen tables (UI only, not sent anywhere).
  getInstructorTotal(column: string): number {
    return this.sumColumn(this.dataSource?.data, column);
  }

  getExecutiveTotal(column: string): number {
    return this.sumColumn(this.staffPerformanceExecutives, column);
  }

  private sumColumn(rows: any[], column: string): number {
    const sum = (rows || []).reduce(
      (acc: number, row: any) => acc + (parseFloat(row?.[column]) || 0), 0);
    return Math.round(sum * 100) / 100;
  }

  currentReport: string = 'staffPerformance';
  week: string;
  year: string;
  staffPerformanceExecutives: any;

  // Get the current studio name from AuthService
  get currentStudio(): string {
    return this._authService.selectedStudio?.name ||
           this._authService.selectedStudio?.key ||
           'Unknown Studio';
  }

  constructor(
    public override _refreshService: RefreshService,
    private _printService: PrintService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  // Get tooltip message for disabled send/update buttons
  get disabledButtonTooltip(): string {
    if (!this.isDisabled) {
      return '';
    }

    if (this.week && this.year) {
      let selectedDate = moment().isoWeekYear(+this.year).isoWeek(+this.week);
      let weekEnd = selectedDate.clone().endOf('isoWeek').startOf('day').add(1, 'day'); // Monday after the week ends
      let now = moment();

      // Calculate days until Monday (when report is actually available)
      let daysUntilReady = Math.ceil(weekEnd.diff(now, 'days', true));

      if (daysUntilReady < 0) {
        return ''; // Should not happen if isDisabled logic is correct
      } else if (daysUntilReady === 1) {
        return 'Ready tomorrow';
      } else {
        return `Ready in ${daysUntilReady} days`;
      }
    }

    return 'Ready after the week ends';
  }

  onYearChange(event: any) {
    this.year = event.value;
    LoggerService.log('year', this.year);
    this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));
  }

  onWeekYearChange(event: WeekYearChangeEvent) {
    this.week = event.week;
    this.year = event.year;
    this.getData([
      { parameter: 'week', value: this.week },
      { parameter: 'year', value: this.year },
    ]);
  }

  override ngAfterContentInit(): void {
    this._activatedRoute.queryParams.subscribe(data => {
      // Stay in the loading state until getData() below runs; clearing it here
      // briefly exposed the "Please select criteria" prompt on every load.

      if (data['year']) {
        this.year = data['year']
      } else {
        this.year = this._fieldsService.getCorrectYearForWeek(new Date()).toString();
      }
      if (data['week']) {
        this.week = data['week']
      } else {
        this.week = this._fieldsService.getCurrentWeek().toString();
      }

      // Update weeks dropdown data to match the year
      this.WeeksForYearData = this._fieldsService.WeeksForYearData(Number.parseInt(this.year));

      this.getData([
        { parameter: 'week', value: this.week},
        { parameter: 'year', value: this.year},
      ]);
    })
  }

  override getData(params: { parameter: string; value: string; }[]) {
    // Create a moment object for the selected week/year
    let selectedDate = moment().isoWeekYear(+this.year).isoWeek(+this.week);
    // Get end of selected week (Sunday)
    let weekEnd = selectedDate.clone().endOf('isoWeek');
    // Create current date for comparison
    let currentDate = moment();

    // Compare the dates - disable if current date hasn't passed Sunday of the selected week
    this.isDisabled = !weekEnd.isBefore(currentDate);

    this.clearFormTableData();

    // Show Progress Bar (Loading indicator)
    this.ShowProgressBar = true;
    this.queryParams = params;

    // Add sorting paramaters, if available.
    if (this.sortParams !== undefined) {
      this.queryParams.push(this.sortParams)
    }

    // Load the new student list with the filtering parameters.
    this._utilityService.getStaffPerformanceReport(
      this.queryParams
    )
      .subscribe((data) => {
        let rows: any = data?.['#staff_content_table']?.['staff_data_4_system']?.['#rows'];
        // ShowProgressBar
        this.ShowProgressBar = false;

        if (!rows) { return; }

        // Modify data to work in Angular.
        rows.forEach((element: { name: string; }, index: string | number) => {
          if (data['#staff_content_table']?.['staff_data_4_system']?.['#rows']?.[index]?.['name']) {
            data['#staff_content_table']['staff_data_4_system']['#rows'][index]['name'] = element.name.replace(/<[^>]*>?/gm, '');
          }
        });

        // Extract the refunds from the rows to be displayed seperately.
        this.filterExecutives(rows);

        this.data = data;
        this.dataSource = new MatTableDataSource(this.filterInstructors(rows) ?? []);
        this.pageSize = rows.length;

        // Pagination configuration.
        this.updatePaginationConfig(rows);
      },
        error => this.handleError(error)
      )
  }

  filterExecutives(rows) {
    this.staffPerformanceExecutives = rows.filter(object => {
      let isExecutive = (object.staff_type == "EXECUTIVE");

      return (isExecutive);
    });
  }

  filterInstructors(rows) {
    return rows.filter(object => {
      let isInstructor = (object.staff_type == "INSTRUCTOR");

      return (isInstructor);
    });
  }

  override setupPagination(data: any, params: { parameter: string; value: string; }[]) {
    const pageParam = params.find(param => param.parameter === 'page');

    // Check if paginator exists before accessing its properties
    if (this.paginator) {
      this.paginator.length = data?.['count'] ?? 0;
      this.paginator.pageSize = this.pageSize;
      this.paginator.pageIndex = pageParam ? parseInt(pageParam.value, 10) : 0;
    }

    // DO NOT call updateRouterParams here - this prevents duplicate requests
    // The routing has already been handled by pageChanged() or other methods
    LoggerService.log('setupPagination called - skipping route update to prevent duplicates');
  }

  override onPrint() {
    let content = `
      <h2 class="report-title">Staff Performance Report</h2>
      <p class="report-period">Week ${this.week}, ${this.year}</p>
      <p class="report-studio">${this.currentStudio}</p>
    `;

    // Instructors Section
    if (this.dataSource.data && this.dataSource.data.length > 0) {
      content += `
        <div class="section">
          <h3>Instructors</h3>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Staff Type</th>
                <th># of Guest</th>
                <th>DE/Bonus</th>
                <th>Private Lessons</th>
                <th>Non Unit/Coaching</th>
                <th># In Class</th>
                <th>DOR/Sanct/Competition</th>
                <th>Showcase/Medal Ball</th>
                <th>Party Time/Non-Unit</th>
                <th>Interview Dept</th>
                <th>Renewal Dept</th>
              </tr>
            </thead>
            <tbody>
              ${this.dataSource.data.map((row: any) => `
                <tr>
                  <td>${row.name || ''}</td>
                  <td>${row.staff_type || ''}</td>
                  <td>${row.number_of_guest || 0}</td>
                  <td>${row['de/bonus'] || 0}</td>
                  <td>${row.private_lessons || 0}</td>
                  <td>${row.non_unit_coaching || 0}</td>
                  <td>${row.number_in_class || 0}</td>
                  <td>${row.dor_sanct_competition || 0}</td>
                  <td>${row.showcase_medal_ball || 0}</td>
                  <td>${row.party_time_non_unit || 0}</td>
                  <td>${row.interview_department || 0}</td>
                  <td>${row.renewal_department || 0}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    // Executives Section
    if (this.staffPerformanceExecutives && this.staffPerformanceExecutives.length > 0) {
      content += `
        <div class="section">
          <h3>Executives</h3>
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Staff Type</th>
                <th># of Guest</th>
                <th>DE/Bonus</th>
                <th>Private Lessons</th>
                <th>Non Unit/Coaching</th>
                <th># In Class</th>
                <th>DOR/Sanct/Competition</th>
                <th>Showcase/Medal Ball</th>
                <th>Party Time/Non-Unit</th>
                <th>Interview Dept</th>
                <th>Renewal Dept</th>
              </tr>
            </thead>
            <tbody>
              ${this.staffPerformanceExecutives.map((row: any) => `
                <tr>
                  <td>${row.name || ''}</td>
                  <td>${row.staff_type || ''}</td>
                  <td>${row.number_of_guest || 0}</td>
                  <td>${row['de/bonus'] || 0}</td>
                  <td>${row.private_lessons || 0}</td>
                  <td>${row.non_unit_coaching || 0}</td>
                  <td>${row.number_in_class || 0}</td>
                  <td>${row.dor_sanct_competition || 0}</td>
                  <td>${row.showcase_medal_ball || 0}</td>
                  <td>${row.party_time_non_unit || 0}</td>
                  <td>${row.interview_department || 0}</td>
                  <td>${row.renewal_department || 0}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    }

    const styles = `
      .report-studio {
        text-align: center;
        font-size: 14px;
        margin-bottom: 15px;
        font-weight: bold;
      }
      /* Layout and page setup */
      @media print {
        @page {
          size: landscape;
          margin: 0.4in;
        }
        body {
          zoom: 1;
          transform: scale(1);
          transform-origin: top left;
          width: 100%;
          padding: 0 !important; /* Override print service padding */
        }
      }
      .report-title {
        font-size: 18px;
        margin-bottom: 5px;
      }
      .report-period {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .section {
        margin-bottom: 15px;
      }
      .section h3 {
        font-size: 14px;
        margin: 5px 0;
      }
      table {
        font-size: 9px;
        width: 100%;
      }
      th, td {
        padding: 2px 3px;
      }
    `;

    this._printService.print(content, {
      title: `Staff Performance Report - Week ${this.week}, ${this.year}`,
      styles: styles,
      promptPrint: true
    });
  }
}
